import { createRouter, createWebHistory } from 'vue-router'
import appRoutes from './app-routes'
import partnerRoutes from './partner-routes'
import { useUserStore } from "@/stores/user";
import { useUserPartnerStore } from "@/stores/userPartner";
import { useIdleStore } from "@/stores/idle";



const routes = [
  ...appRoutes,
  ...partnerRoutes
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  },
})

router.beforeEach(async (to, from, next) => {
  document.title = 'ZeeClip - ' + to.meta?.title;

  const userStore = useUserStore();
  const userPartnerStore = useUserPartnerStore()
  const idleStore = useIdleStore();

  // Bloqueo por seguridad: si la sesión expiró por inactividad,
  // forzamos logout para evitar que un refresh permita seguir navegando.
  if (to.meta.requiresAuth && idleStore.sessionExpired) {
    userStore.setLogout();
    return next({ name: 'login' });
  }

  // 🚧 Si requiere login normal
  if (to.meta.requiresAuth) {
    if (!userStore.isAuthenticated) {
      return next({ name: 'login' });
    }
  }

  // 🚧 Si requiere login de partner
  if (to.meta.requiresPartnerAuth) {
    if (!userPartnerStore.isAuthenticated) {
      return next({ name: 'partnerLogin' });
    }
  }

  // ✅ Si no requiere autenticación o ya está autenticado
  next();
});


export default router
